export interface Category {
  slug: string;
  name: string;
  icon: string;
  tagline: string;
  description: string;
  banner: string;
}

export const categories: Category[] = [
  {
    slug: "blood",
    name: "热血",
    icon: "ri-fire-fill",
    tagline: "燃到发烫的战斗与成长",
    description:
      "热血漫画是无数漫迷的第一站。这里有拳拳到肉的对决、并肩作战的羁绊，以及从普通少年一步步走向巅峰的滚烫旅程，每一次突破都让人热血沸腾。",
    banner:
      "https://readdy.ai/api/search-image?query=Dramatic%20hot-blooded%20shounen%20anime%20key%20visual%2C%20intense%20battle%20pose%20with%20fierce%20fire%20and%20lightning%20effects%2C%20bold%20warm%20orange%20and%20crimson%20color%20palette%2C%20cinematic%20dynamic%20composition%2C%20high%20contrast%20stylized%20manga%20art%20background&width=1600&height=520&seq=cat-blood&orientation=landscape",
  },
  {
    slug: "suspense",
    name: "悬疑",
    icon: "ri-eye-line",
    tagline: "烧脑反转，真相层层剥开",
    description:
      "悬疑漫画把读者拖进迷雾之中。每一话都埋下线索与陷阱，真相往往比想象更出人意料。喜欢推理与反转的你，一定不能错过这个榜单。",
    banner:
      "https://readdy.ai/api/search-image?query=Moody%20mystery%20thriller%20anime%20key%20visual%2C%20silhouette%20figure%20under%20foggy%20streetlight%20with%20magnifying%20glass%20and%20scattered%20clues%2C%20dark%20teal%20and%20deep%20charcoal%20palette%20with%20subtle%20amber%20glow%2C%20suspenseful%20cinematic%20manga%20background&width=1600&height=520&seq=cat-suspense&orientation=landscape",
  },
  {
    slug: "healing",
    name: "治愈",
    icon: "ri-leaf-line",
    tagline: "温柔日常，抚平内心褶皱",
    description:
      "治愈漫画用细水长流的日常抚慰人心。一餐暖饭、一束晨光、一句问候，都在告诉你：生活再忙，也要记得好好爱自己。",
    banner:
      "https://readdy.ai/api/search-image?query=Gentle%20healing%20slice-of-life%20anime%20key%20visual%2C%20cozy%20sunlit%20cafe%20with%20warm%20tea%20and%20soft%20morning%20light%2C%20cream%20beige%20and%20soft%20rose%20pastel%20palette%2C%20peaceful%20relaxing%20manga%20art%20background&width=1600&height=520&seq=cat-healing&orientation=landscape",
  },
  {
    slug: "romance",
    name: "恋爱",
    icon: "ri-heart-3-line",
    tagline: "心动瞬间，甜到心坎里",
    description:
      "恋爱漫画记录每一次怦然心动。青涩的告白、默契的对视、漫长的心事，酸甜交织的恋爱日常，总能让人会心一笑。",
    banner:
      "https://readdy.ai/api/search-image?query=Romantic%20youth%20anime%20key%20visual%2C%20cherry%20blossom%20petals%20falling%20around%20two%20silhouettes%20at%20sunset%2C%20soft%20pink%20peach%20and%20lilac%20palette%2C%20dreamy%20gentle%20light%2C%20sweet%20love%20story%20manga%20background&width=1600&height=520&seq=cat-romance&orientation=landscape",
  },
  {
    slug: "scifi",
    name: "科幻",
    icon: "ri-rocket-2-line",
    tagline: "穿越星海，探索未来边界",
    description:
      "科幻漫画把想象推向星辰大海。机甲、太空、人工智能、量子世界，在脑洞大开的设定里，思考人类的现在与未来。",
    banner:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20anime%20key%20visual%2C%20astronaut%20facing%20a%20giant%20neon%20planet%20and%20mecha%20silhouette%2C%20deep%20navy%20and%20vivid%20magenta%20cyan%20nebula%20glow%2C%20epic%20space%20manga%20background&width=1600&height=520&seq=cat-scifi&orientation=landscape",
  },
  {
    slug: "comedy",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    tagline: "笑到停不下来的欢乐日常",
    description:
      "搞笑漫画是日常的解压良药。无厘头的情节、夸张的表情、默契的吐槽，一话一个笑点，让你烦恼全消、笑出眼泪。",
    banner:
      "https://readdy.ai/api/search-image?query=Playful%20funny%20comedy%20anime%20key%20visual%2C%20colorful%20cartoon%20characters%20laughing%20with%20exaggerated%20expressions%20and%20bouncing%20comic%20sound%20effects%2C%20bright%20cheerful%20orange%20yellow%20and%20aqua%20palette%2C%20lighthearted%20manga%20background&width=1600&height=520&seq=cat-comedy&orientation=landscape",
  },
];

export const categoryMap = categories.reduce<Record<string, Category>>(
  (acc, c) => {
    acc[c.slug] = c;
    return acc;
  },
  {},
);